import { Address } from '../address';
import { AddressDto } from '../dto/address-dto';

export const mapAddress = (address: AddressDto): Address => {
    const city = `${address.zip} ${address.city}`.trim();
    const street = `${address.street} ${address.number}`.trim();

    const fullAddress = [city, street].filter(Boolean).join(', ');
    const fullAddressWithTitle = [fullAddress, address.title].filter(Boolean).join(', ');

    return {
        id: address.id,
        addition: address.addition,
        city: address.city,
        countryName: address.countryName,
        note: address.note,
        number: address.number,
        postboxNumber: address.postboxNumber,
        regionName: address.region?.name,
        regionCode: address.region?.code,
        street: address.street,
        title: address.title,
        zip: address.zip,
        costCentre: address.costCentre,
        isInvoiceAddress: address.isInvoiceAddress ?? true,
        isDeliveryAddress: address.isDeliveryAddress ?? true,
        isMainAddress: address.isMainAddress ?? true,
        fullAddress,
        fullAddressWithTitle,
    };
};
